module.exports = __webpack_public_path__ + "static/media/tshirt-woman-back-min.71ec6f03.png";